// styles.js
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		background: "#f8faf9",
		minHeight: "100vh",
		padding: theme.spacing(4),
		"& .searchWrapper": {
			padding: "10px !important",
		},
		"& .select__value-container": {
			height: "100%",
			flexWrap: "wrap !important",
		},
		"& .css-b8ldur-Input": {
			width: "auto !important",
		},
		"& .MuiCard-root": {
			overflow: "visible"
		}
	},
	mainCard: {
		borderRadius: "20px",
		boxShadow: "0 20px 60px rgba(156, 197, 75, 0.08)",
		overflow: "visible",
		background: "#ffffff",
	},
	header: {
		padding: theme.spacing(4),
		borderRadius: "20px 20px 0 0",
		position: "relative",
		borderBottom: "3px solid #9cc54b",
	},
	headerTitle: {
		fontWeight: 700,
		fontSize: "2rem",
		color: "#2d3748",
		position: "relative",
		zIndex: 1,
	},
	headerSubtitle: {
		color: "#718096",
		marginTop: "8px",
		fontSize: "1rem",
	},
	contentSection: {
		padding: theme.spacing(4),
	},
	sectionTitle: {
		fontSize: "1.1rem",
		fontWeight: 600,
		color: "#2d3748",
		marginBottom: theme.spacing(2),
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1),
		"&::before": {
			content: '""',
			width: "4px",
			height: "24px",
			background: "#9cc54b",
			borderRadius: "2px",
		},
	},
	inputField: {
		"& .MuiOutlinedInput-root": {
			borderRadius: "12px",
			transition: "all 0.3s ease",
			"&:hover": {
				boxShadow: "0 4px 12px rgba(156, 197, 75, 0.15)",
			},
			"&.Mui-focused": {
				boxShadow: "0 4px 16px rgba(156, 197, 75, 0.25)",
				"& .MuiOutlinedInput-notchedOutline": {
					borderColor: "#9cc54b",
				},
			},
		},
		"& .MuiInputLabel-root.Mui-focused": {
			color: "#9cc54b",
		},
	},
	conditionCard: {
		border: "2px solid #e2f0d3",
		background: "#ffffff",
		borderRadius: "16px",
		padding: theme.spacing(3),
		marginBottom: theme.spacing(3),
		zIndex: 1,
		"& .MuiCard-root": {
			overflow: "visible "
		},
		"&:hover": {
			borderColor: "#9cc54b",
		},
	},
	groupHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginBottom: theme.spacing(3),
	},
	groupBadge: {
		background: "#9cc54b",
		color: "white",
		padding: "8px 20px",
		borderRadius: "20px",
		fontWeight: 600,
		fontSize: "1rem",
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1),
	},
	productCount: {
		background: "rgba(255, 255, 255, 0.3)",
		padding: "4px 12px",
		borderRadius: "12px",
		fontSize: "0.9rem",
	},
	orDivider: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		margin: theme.spacing(3, 0),
		position: "relative",
		"&::before, &::after": {
			content: '""',
			flex: 1,
			height: "2px",
			background: "linear-gradient(90deg, transparent, #9cc54b, transparent)",
		},
	},
	orText: {
		padding: "8px 24px",
		background: "#9cc54b",
		color: "white",
		borderRadius: "20px",
		fontWeight: 600,
		margin: "0 16px",
		fontSize: "0.9rem",
		letterSpacing: "1px",
	},
	imagePreview: {
		borderRadius: "16px",
		overflow: "hidden",
		boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
		transition: "transform 0.3s ease",
		"&:hover": {
			transform: "scale(1.02)",
		},
	},
	logoPreview: {
		width: "180px",
		height: "180px",
		borderRadius: "50%",
		overflow: "hidden",
		boxShadow: "0 8px 24px rgba(156, 197, 75, 0.2)",
		border: "4px solid #e2f0d3",
	},
	actionButton: {
		borderRadius: "12px",
		padding: "12px 32px",
		textTransform: "none",
		fontWeight: 600,
		fontSize: "1rem",
		boxShadow: "0 4px 12px rgba(156, 197, 75, 0.3)",
		transition: "all 0.3s ease",
		"&:hover": {
			transform: "translateY(-2px)",
			boxShadow: "0 6px 20px rgba(156, 197, 75, 0.4)",
		},
	},
	primaryButton: {
		background: "#9cc54b",
		color: "white",
		"&:hover": {
			background: "#8ab43d",
		},
	},
	iconButton: {
		transition: "all 0.3s ease",
		"&:hover": {
			transform: "rotate(90deg)",
		},
	},
	checkboxLabel: {
		"& .MuiTypography-root": {
			fontWeight: 500,
			// color: "#4a5568",
		},
		"& .MuiCheckbox-colorPrimary.Mui-checked": {
			// color: "#9cc54b",
		},
	},
	uploadButton: {
		border: "2px dashed #cbd5e0",
		borderRadius: "12px",
		padding: theme.spacing(3),
		textAlign: "center",
		cursor: "pointer",
		transition: "all 0.3s ease",
		"&:hover": {
			borderColor: "#9cc54b",
			background: "rgba(156, 197, 75, 0.05)",
		},
	},
	conditionRow: {
		background: "#f8faf9",
		padding: theme.spacing(2),
		borderRadius: "12px",
		marginBottom: theme.spacing(2),
	},
	selectField: {
		borderRadius: "12px",
		"& .MuiOutlinedInput-root": {
			borderRadius: "12px",
			"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
				borderColor: "#9cc54b",
			},
		},
	},
	addButton: {
		borderRadius: "12px",
		textTransform: "none",
		fontWeight: 600,
		marginTop: theme.spacing(2),
	},
	floatingActionBar: {
		position: "sticky",
		bottom: theme.spacing(3),
		background: "white",
		padding: theme.spacing(2, 4),
		borderRadius: "16px",
		boxShadow: "0 12px 32px rgba(156, 197, 75, 0.2)",
		display: "flex",
		justifyContent: "flex-end",
		gap: theme.spacing(2),
		marginTop: theme.spacing(4),
		zIndex: 100,
		border: "1px solid #e2f0d3",
		"& .MuiCard-root": {
			overflow: "visible"
		}
	},
	generateSlugButton: {
		background: "#9cc54b",
		color: "white",
		"&:hover": {
			background: "#8ab43d",
		},
	},
}));

export default useStyles;
